<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">Pilih Barang</h5>
            </b-card-header>
            <b-card-body>
                <div class="mb-3">
                    <div class="search-bar">
                        <form class="form-inline">
                            <div class="form-group mr-2">
                                <label class="mr-sm-2">Pencarian</label>
                                <input type="text" v-model="searchText" class="form-control" @keyup.enter="searchSet"
                                    placeholder="kode..." data-lpignore="true">
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" @click.prevent="searchSet">Cari</button>
                                <button class="btn btn-light" @click.prevent="searchReset">Reset</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="table-responsive" v-show="searchText">
                    <vuetable ref="vuetable"
                        api-url="/api/pembelian-tembakaus"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action-slot" slot-scope="props">
                            <button type="button" title="Pilih" @click="select(props.rowData)" class="btn btn-primary"><i class="fas fa-check"></i> Pilih</button>
                        </template>
                    </vuetable>
                </div>
                <div v-show="!oneData">
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div v-show="!oneData">
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div v-show="!oneData">
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button @click="$emit('cancel')" type="button" class="btn btn-primary">OK</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import VuetableMixin from '../mixin/vuetable2';

export default {
    name: "barang-selector",

    props: {
        selected: {
            type: Array,
            default: () => [],
        },

        oneData: {
            type: Boolean,
            default: false,
        },

        allData: {
            type: Boolean,
            default: false,
        },

        latestGudangId: {
            type: Number,
            default: null,
        },
    },

    components: {
    },

    mixins: [VuetableMixin],

    data() {
        return {
            perPage: 10,
            currentUser: null,
            searchText: '',
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'code',
                    title: 'Kode',
                    sortField: 'code',
                },
                {
                    name: 'latest_gudang.name',
                    title: 'Gudang',
                    sortField: 'latest_gudang_name',
                },
                {
                    name: 'latest_bobot',
                    title: 'Berat',
                    sortField: 'latest_bobot',
                },
                {
                    name: 'latest_grade.name',
                    title: 'Grade',
                    sortField: 'latest_grade_name',
                },
                {
                    name: '__slot:action-slot',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                latest_gudang_id: this.latestGudangId,
                is_pilih: true,
                all_data: this.allData,
            };
        },
    },

    methods: {
        searchSet() {
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.refresh();
        },

        select(data) {
            let self = this;
            if (self.selected.find((b) => b.id == data.id)) {
                Toast.fire({
                    icon: 'warning',
                    title: 'Barang ' + data.code + ' sudah dipilih.'
                });
                return;
            }
            this.$emit('selected', data);
        },
    },
}
</script>
